const process = document.querySelector('.steelsasquatch_process');
/**
 * make sure we don't run this script if the slideshow is not present
 */
if (process !== null) {
	const btns = document.getElementsByClassName('process');

	//add active class to the first split content block onload
	split_content = document.querySelectorAll('.split-content'),
		splitContent = split_content.length,
		split_content[0].classList.add('active');

	//add active class to first process btn block
	processBtn = document.querySelectorAll('.process'),
		processCount = processBtn.length,
		processBtn[0].classList.add('active');

	//Find the number of process btns - on click remove any active classes then add active class to this one
	for (let i = 0; i < btns.length; i++) {
		btns[i].addEventListener('click', function () {
			block_number = i;
			const process_current = document.getElementsByClassName('process active');
			var split_content_current = document.getElementsByClassName('split-content active');

			if (process_current.length > 0) {
				process_current[0].className = process_current[0].className.replace('active', '');
				split_content_current[0].className = split_content_current[0].className.replace('active', '');
				this.className += ' active';
				split_content[block_number].classList.add('active');
			};

		});
	};
};
